
import { mapActions, mapGetters, mapState } from 'vuex'
import { mdiInformation, mdiArrowDownThin, mdiLockOutline, mdiInformationOutline } from '@mdi/js'
import CountDown from '@/components/catalog/product/CountDown'
import utils from '@/components/tools/utils'
import api from '@/components/tools/api'
import auction from '@/components/tools/auction'
import time from '@/components/tools/time'
import ObfuscateTooltip from '@/components/catalog/ObfuscateTooltip'
import AddToRemoveFromWatchlist from '@/components/catalog/AddToRemoveFromWatchlist'
import NewAuctionActions from '@/components/catalog/product/NewAuctionActions'
import BiddingAgentExpansionCard from '@/components/catalog/product/BiddingAgentExpansionCard'
import CustomerContextOwnerProductChip from '@/components/catalog/chips/CustomerContextOwnerProductChip'
import CustomerContextProductChip from '@/components/catalog/chips/CustomerContextProductChip'
import AuctionStatusChip from '@/components/catalog/chips/AuctionStatusChip'
import BuyNowProductChip from '@/components/catalog/chips/BuyNowProductChip.vue'
import PrivateAuctionProductChip from '@/components/catalog/chips/PrivateAuctionProductChip.vue'
import OldTargetPriceTooltip from '@/components/catalog/product/OldTargetPriceTooltip.vue'
import AuctionHistory from '@/components/catalog/product/AuctionHistory.vue'

export default {
  icons: {
    mdiInformation,
    mdiArrowDownThin,
    mdiLockOutline,
    mdiInformationOutline
  },
  components: {
    AuctionHistory,
    OldTargetPriceTooltip,
    PrivateAuctionProductChip,
    BuyNowProductChip,
    AuctionStatusChip,
    CustomerContextProductChip,
    CustomerContextOwnerProductChip,
    BiddingAgentExpansionCard,
    NewAuctionActions,
    AddToRemoveFromWatchlist,
    ObfuscateTooltip,
    CountDown
  },
  data: () => ({
    now: Date.now(),
    interval: undefined
  }),
  computed: {
    ...mapGetters({ isAdmin: 'isUserAdmin' }),
    ...mapState('general', ['differenceToServerTime']),
    ...mapState('customer', {
      merchantAcceptedByCm24: state => state.merchant?.acceptedByCm24 === true,
      customer: state => state.customer,
      merchant: state => state.merchant,
      merchantAddress: state => state.merchantAddress,
      merchantInReview: state => state.merchant?.merchantId && state.merchant?.acceptedByCm24 === null,
      privateProfileCompleted: state => state.customer?.privateProfileCompleted === true,
      privateCustomer: state => !state.merchant?.merchantId,
      loading: state => state.customer?.customerId === undefined || state.customer?.customerId === null
    }),
    ...mapState('product', {
      product: state => state.data,
      status: state => state.data?.auction?.status,
      anrs: state => state.data?.auction?.anrs,
      renegStatus: state => state.data?.auction?.renegStatus,
      orderStatus: state => state.data?.auction?.orderStatus,
      entityId: state => state.data?.entityId,
      auctionId: state => state.data?.auction?.auctionId,
      vatReportable: state => state.data?.auction?.vatReportable,
      zipcodeCaravan: state => 'D-' + state.data?.auction?.zipcodeCaravan?.toString(),
      distanceToMyLocation: state => state.data?.context?.distanceToMyLocation + ' km',
      currentPrice: state => state.data?.auction?.currentPrice,
      startPrice: state => state.data?.auction?.startPrice,
      targetPrice: state => state.data?.auction?.targetPrice,
      autoRound: state => state.data?.auction?.autoRound,
      buyNowPrice: state => state.data?.auction?.buyNowPrice,
      buyNowEnabled: state =>
        state.data.auction?.buyNowEnabled && state.data.auction?.buyNowPrice != null && state.data.auction.hasBids === false && state.data.auction.autoRound === false,
      privateAuction: state => state.data?.auction?.privateAuction,
      nextBidPrice: state => state.data?.auction?.nextBidPrice,
      maxAllowedBidPrice: state => state.data?.auction?.maxAllowedBidPrice,
      renegotiationThreshold: state => state.data?.auction?.renegotiationThreshold,
      showBiddingAdviser: state => state.data?.auction?.showBiddingAdviser,
      step: state => state.data?.auction?.step,
      // endingAt: state =>
      startingAt: state => time.parseDate(state.data?.auction?.startingAt),
      availableAt: state => time.parseDate(state.data?.auction?.availableAt),

      endingAt (state) {
        if (state.data?.auction?.renegEndingAt) {
          return time.parseDate(state.data?.auction?.renegEndingAt)
        } else {
          return time.parseDate(state.data?.auction?.endingAt)
        }
      },

      watchlistAuctionStatusFilter (state) {
        if (state.data?.auction?.renegStatus === 'late_counter_offer_opened') {
          return 'renegotiation'
        } else {
          return state.data?.auction?.status
        }
      },

      waitingForAnswer: state => state.data?.context?.waitingForAnswer,
      auctionFee (state) {
        if (state.data.auction?.auctionFee === 0) {
          return undefined
        } else {
          return state.data.auction?.auctionFee
        }
      },

      availableNow (state) {
        return state.data?.auction?.availableNow || this.availableAt < Date.now()
      }
    }),

    showCurrentPrice () {
      if (['under_review', 'published'].includes(this.status) && this.isOwner && !this.hasBids) {
        return false
      } else if (this.status === 'acpt_late_offer' && !this.hasBids) {
        return false
      }
      return true
    },

    maxWidthTooltip () {
      if (this.$vuetify.breakpoint.mobile) {
        return '60vw'
      } else {
        return '40vw'
      }
    },
    colsMinHeight () {
      if (this.$vuetify.breakpoint.lgAndUp) {
        return '70px'
      } else if (this.$vuetify.breakpoint.smAndUp) {
        return '60px'
      }
      return 'auto'

      // if (!this.$vuetify.breakpoint.mobile) {
      //   return '70px'
      // } else {
      //   return 'auto'
      // }
    },

    vatPercentage () {
      if (this.product?.vatPercentage) {
        return this.product.vatPercentage
      }
      return 19
    },

    isOnWatchList () {
      return this.product?.context?.watchlist === true
    },

    isWatchlistButtonDisabled () {
      const {
        context,
        customerId
      } = this.product

      if (context?.holdingHighestBid || this.customerId === customerId) {
        return true
      }
      return false
      // return ![undefined, null].includes(context?.holdingHighestBid) || this.customerId === customerId
    },

    hasBiddingContext () {
      return !(this.product?.context?.holdingHighestBid === undefined || this.product?.context?.holdingHighestBid === null) ||
        this.product.context?.hasFailedLateOfferOnProduct === true
    },

    auctionActive () {
      const secondsLeft = Math.ceil((this.endingAt - this.now) / 1000)
      return secondsLeft > 0
    },
    holdingHighestBid () {
      return this.product?.context?.holdingHighestBid === true
    },

    auctionPriceTitle () {
      return auction.auctionPriceTitle(this.product, this.isOwner, this.$auth.loggedIn)
    },
    loggedIn () {
      return this.$auth.loggedIn
    },

    isOwner () {
      return this.customer?.customerId === this.product?.customerId
    },
    currentPriceColor () {
      return utils.currentPriceColor(this.product)
    },
    currentPriceOwner () {
      if (this.product?.auction?.currentPrice && (this.status === 'running' || this.status === 'sold' || this.status === 'failed' ||
        this.status === 'renegotiation' || this.status === 'recd_late_offer')) {
        return this.product?.auction?.hasBids ? this.formatCurrency(this.currentPrice) : '-'
      } else {
        return '-'
      }
    },
    hasBids () {
      return this.product?.auction?.hasBids
    },
    styleButtonText () {
      if (this.$vuetify.breakpoint.mobile) {
        if (process.client) {
          return {
            'max-width': window.innerWidth - 120 + 'px'
          }
        } else {
          return {
            'max-width': '300px'
          }
        }
      } else {
        return {}
      }
    },
    buttonSize () {
      const size = { xs: 'large' }[this.$vuetify.breakpoint.name]
      return size ? { [size]: true } : {}
    }

  },
  mounted () {
    const that = this
    this.interval = setInterval(function () {
      that.now = Date.now() - that.differenceToServerTime
    }, 1000)
  },
  beforeDestroy () {
    clearInterval(this.interval)
  },
  methods: {
    ...mapActions('product', ['getProduct', 'setAuctionEndingAt']),

    async login () {
      await api.addDefaultAfterLoginRedirectActions(this)
      await this.$router.push(this.localePath({ name: 'auth-login' }))
    },

    getPercentageDifference (a, b) {
      return utils.getPercentageDifference(a, b)
    },
    formatCurrency (value) {
      return utils.formatCurrency(value)
    },

    formatDate (value) {
      return utils.formatDate(value, this.$i18n.locale)
    },
    formatDateWithoutTime (value) {
      return utils.formatDateWithoutTime(value)
    },

    refreshCallback () {
      return this.getProduct(this.entityId)
    },

    async goToMyAds () {
      await this.$router.push(this.localePath({
        name: 'account-my-vehicles'
      }))
    }

  }
}
